<section class="page">
  <header class="page-header">
    <h2>Export Excel des positions GPS</h2>
    <p class="subtitle">Exporter les positions GPS de tous les capteurs au format Excel.</p>
  </header>

  <section class="panel">
    @if (error) {
      <p class="error">{{ error }}</p>
    }

    @if (success) {
      <p class="success">{{ success }}</p>
    }

    <div class="export-container">
 
      

      <button
        type="button"
        class="btn-export"
        [disabled]="exporting"
        (click)="exportPositions()"
      >
        {{ exporting ? 'Export en cours...' : 'Exporter les positions GPS des capteurs en Excel' }}
      </button>
    </div>
  </section>
</section>
